import axios from 'axios';
import authHeader from 'services/auth-header';
import { setupInterceptors } from 'apis/interceptor';

const API = process.env.REACT_APP_API_URL;

export const apiGet = async <T>(url:string): Promise<T> => {
  const instance =
    axios.create({
      baseURL: API,
      timeout:5000,
      headers: authHeader(),
    });

  return await instance.get<T>(url).then((res) => res.data );
}

export const apiPost = async <T>(url: string, body: any): Promise<T> => {
  const instance = 
    axios.create({
      baseURL: API,
      timeout: 5000,
      headers: authHeader(),
    });

  return await instance.post<T>(url, body).then((res) => res.data ).catch((error) => {
    console.error("Error in apiPost:", error);
    throw error;
  });
}

export const apiPatch = async (url:string, body: any) => {
  const instance = setupInterceptors(
    axios.create({
      baseURL: API,
      timeout:1000,
      headers: authHeader(),
      withCredentials:true, //헤더에 Authorization 항목이 있는 요청
    }),
  );
  return await instance.patch(url, body).then((res) => res.data );
}

export const apiDel = async (url:string) => {
  const instance = setupInterceptors(
    axios.create({
      baseURL: API,
      timeout:1000,
      headers: authHeader(),
      withCredentials:true, //헤더에 Authorization 항목이 있는 요청
    }),
  );
  return await instance.delete(url);
}

